module.exports = __webpack_public_path__ + "img/0-79.969e70a2.jpg";